import o from "./getBoundingClientRect.js";
import r from "./getDocumentElement.js";
import e from "./getWindowScroll.js";
function f(t) {
  return o(r(t)).left + e(t).scrollLeft;
}
export {
  f as default
};
